import { createAlertsApi } from '@d-orca/shared/client/apis';
import { authedFetch } from '@apis/auth';

// The shared alert-settings API bound to the web transport (cookie
// `authedFetch`): the person's own settings and the project's Alerts Hub.
export const alertsApi = createAlertsApi(authedFetch);
export const {
  fetchPersonalAlertSettings,
  updatePersonalAlertSetting,
  fetchAlertsHub,
  updateAlertsHub,
  fetchRestrictedAreaOptions,
  createRestrictedArea,
  updateRestrictedArea,
  deleteRestrictedArea,
} = alertsApi;
